import { useState, useEffect } from 'react';

import axios from 'axios';
import routes from 'app/routes';

export default function useEnterpriseTeams({ enterpriseId }) {
  const [teams, setTeams] = useState(null);

  useEffect(() => {
    axios
      .get(routes.api.teams.index, { params: { enterprise_id: enterpriseId } })
      .then((response) => {
        setTeams(response.data.data);
      });
  }, [enterpriseId]);

  return teams;
}
